/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Words_WeightInputs */

const en_us2_search_words_weight = /** @type {(inputs: Search_Words_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`log weight scale weigh kg`)
};

const pt_br2_search_words_weight = /** @type {(inputs: Search_Words_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`registrar peso balanca pesagem kg`)
};

const es_419_search_words_weight = /** @type {(inputs: Search_Words_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`registrar peso bascula pesarse kg`)
};

const pt_pt2_search_words_weight = /** @type {(inputs: Search_Words_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`registar peso balanca pesagem kg`)
};

const fr_fr2_search_words_weight = /** @type {(inputs: Search_Words_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`noter poids balance pesee kg`)
};

const de_de2_search_words_weight = /** @type {(inputs: Search_Words_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`gewicht eintragen waage wiegen kg`)
};

const it_it2_search_words_weight = /** @type {(inputs: Search_Words_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`registra peso bilancia pesata kg`)
};

/**
* | output |
* | --- |
* | "log weight scale weigh kg" |
*
* @param {Search_Words_WeightInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_words_weight = /** @type {((inputs?: Search_Words_WeightInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Words_WeightInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_words_weight(inputs)
	if (locale === "es-419") return es_419_search_words_weight(inputs)
	if (locale === "pt-PT") return pt_pt2_search_words_weight(inputs)
	if (locale === "fr-FR") return fr_fr2_search_words_weight(inputs)
	if (locale === "de-DE") return de_de2_search_words_weight(inputs)
	if (locale === "it-IT") return it_it2_search_words_weight(inputs)
	return en_us2_search_words_weight(inputs)
});
export { search_words_weight as "search.words_weight" }